import {
  Flex,
  Box,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Icon,
  Badge,
  IconButton,
  Select,
  Button,
  useDisclosure,
  Switch,
  Tooltip,
  Spinner,
} from '@chakra-ui/react';
import * as React from 'react';
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';

// Custom components
import Card from 'components/card/Card';
import Menu from 'components/menu/MainMenu';
import {
  MdCheckCircle,
  MdEdit,
  MdOutlineError,
  MdPending,
  MdVisibility,
} from 'react-icons/md';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import Pagination from 'components/pagination';
import { useNavigate } from 'react-router-dom';
import { ProvidersModal } from './ProvidersModal';
import ErrorMessage from 'components/error-message';
import { createAPIEndPoint } from 'config/api/api';
import toast from 'react-hot-toast';
import { formatUSPhoneNumber } from 'utils';
import moment from 'moment';

// Column Helper
const columnHelper = createColumnHelper();

// TeamTable Component
export default function ProvidersTable(props) {
  const { tableData, loading, fetchAgain } = props;
  const navigate = useNavigate();
  const [type, setType] = React.useState('add');
  const [statusFilter, setStatusFilter] = React.useState('');
  const [sorting, setSorting] = React.useState([]);
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

  const [searchTerm, setSearchTerm] = React.useState('');
  console.log(" ProvidersTable ~ searchTerm:", searchTerm)
  const [currentPage, setCurrentPage] = React.useState(1);
  const [itemsPerPage, setItemsPerPage] = React.useState(10);

  const [selectedId, setSelectedId] = React.useState('');


  const [loadingStatus, setLoadingStatus] = React.useState({});


  const handleStatusChange = async (rowIndex, endpoint) => {
    setLoadingStatus((prev) => ({ ...prev, [rowIndex]: true })); // Set loading for this row
    try {
      const response = await createAPIEndPoint(`${endpoint}/${rowIndex}`).patch();
      console.log("Status updated:", response.data);
      fetchAgain(); // Refresh the data

      // Show success toast
      toast.success("Status updated successfully!");
    } catch (error) {
      console.error("Error updating status:", error);

      // Show error toast with dynamic message
      toast.error(error.response?.data?.message || "Failed to update status.");
    } finally {
      setLoadingStatus((prev) => ({ ...prev, [rowIndex]: false })); // Stop loading
    }
  };

  // Columns definition
  const columns = [
    columnHelper.accessor((row, index) => index + 1, {
      id: '#',
      header: () => (
        <Text fontSize="12px" color="gray.400" fontWeight="bold">
          #
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="700">
          {info.getValue() || 'N/A'}
        </Text>
      ),
    }),
    // columnHelper.accessor(
    columnHelper.accessor('provider_name', {
      id: 'provider_name',
      header: () => (
        <Text fontSize="12px" color="gray.400" fontWeight="bold">
          Name
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="700">
          {info.getValue() || 'N/A'}
        </Text>
      ),
    }),
    columnHelper.accessor('email', {
      id: 'email',
      header: () => (
        <Text fontSize="12px" color="gray.400" fontWeight="bold">
          EMAIL
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} textTransform="none" fontSize="sm" fontWeight="700">
          {info.getValue() || 'N/A'}
        </Text>
      ),
    }),
    columnHelper.accessor('phone', {
      id: 'phone',
      header: () => (
        <Text fontSize="12px" color="gray.400" fontWeight="bold">
          PHONE
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="700">
          {formatUSPhoneNumber(info.getValue()) || 'N/A'}
        </Text>
      ),
    }),
    // columnHelper.accessor('npi', {
    //   id: 'npi',
    //   header: () => (
    //     <Text fontSize="12px" color="gray.400" fontWeight="bold">
    //       NPI
    //     </Text>
    //   ),
    //   cell: (info) => (
    //     <Text color={textColor} fontSize="sm" fontWeight="700">
    //       {info.getValue() || 'N/A'}
    //     </Text>
    //   ),
    // }),
    // columnHelper.accessor('tin', {
    //   id: 'tin',
    //   header: () => (
    //     <Text fontSize="12px" color="gray.400" fontWeight="bold">
    //       TIN
    //     </Text>
    //   ),
    //   cell: (info) => (
    //     <Text color={textColor} fontSize="sm" fontWeight="700">
    //       {info.getValue() || 'N/A'}
    //     </Text>
    //   ),
    // }),
    // columnHelper.accessor('status', {
    //   id: 'status',
    //   header: () => (
    //     <Text fontSize="12px" color="gray.400" fontWeight="bold">
    //       Status
    //     </Text>
    //   ),
    //   cell: (info) => {
    //     const role = info.getValue() || 'N/A';
    //     const roleColors = {
    //       enable: 'green',
    //       disable: 'red',
    //     };

    //     return (
    //       <Badge
    //         colorScheme={roleColors[role] || 'gray'}
    //         px={2}
    //         py={1.5}
    //         borderRadius="md"
    //         textAlign="center"
    //         minWidth="72px"
    //       >
    //         <Text fontSize="sm" textTransform="capitalize" fontWeight="700">
    //           {role}
    //         </Text>
    //       </Badge>
    //     );
    //   },
    // }),
    columnHelper.accessor('status', {
      id: 'status_update',
      header: () => (
        <Text fontSize="12px" color="gray.400" fontWeight="bold">
          {/* Update  */}
          Status
        </Text>
      ),
      cell: (info) => {
        return (
          <Tooltip textTransform="capitalize" label={info.row.original.status} hasArrow>
            <span>
              {loadingStatus[info.row.original.id] ? ( // Show spinner if loading
                <Spinner size="md" mx="auto" display="flex" color="blue.500" />
              ) : (
                <Switch
                  isChecked={info.row.original.status === "enable"}
                  onChange={() => handleStatusChange(info.row.original.id, "clinic_providers")}
                  colorScheme={info.row.original.status === "enable" ? "green" : "red"}
                  isDisabled={loadingStatus[info.row.original.id]} // Disable switch while loading
                />
              )}
            </span>
          </Tooltip>

        );
      },
    }),
    columnHelper.accessor('created_at', {
      id: 'created_at',
      header: () => (
        <Text fontSize="12px" color="gray.400" fontWeight="bold">
          Added at
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="700">
          {info.getValue() ? moment(info.getValue()).format('MM/DD/YYYY') : 'N/A'}
        </Text>
      ),
    }),
    columnHelper.accessor('action', {
      id: 'action',
      header: () => (
        <Text fontSize="12px" color="gray.400" fontWeight="bold">
          ACTION
        </Text>
      ),
      cell: (info) => {
        const handleEditClick = () => {
          const itemId = info.row.original.id; // Get the id from row data

          setSelectedId(itemId);
          onOpen();
          setType('edit');
        };

        const handleViewClick = () => {
          const id = info.row.original.id; // Get the id from row data
          console.log('Navigating to details with ID:', id);

          navigate(`details/${id}`, { state: { id: id } }); // Pass ID in state
        };

        return (
          <Box display="flex">
            <IconButton
              icon={<MdEdit style={{ marginLeft: '-1px' }} />}
              aria-label="Edit Details"
              colorScheme="brand"
              size="sm"
              mr="6px"
              onClick={handleEditClick}
            />
            <IconButton
              icon={<MdVisibility style={{ marginLeft: '-1px' }} />}
              aria-label="View Details"
              colorScheme="blackAlpha"
              size="sm"
              mr="6px"
              onClick={handleViewClick}
            />
          </Box>
        );
      },
    }),
  ];


  const { isOpen, onOpen, onClose } = useDisclosure();
  const [data, setData] = React.useState([]);
  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });

  React.useEffect(() => {
    if (!tableData) return;

    let filteredData = [...tableData]; // Work on a copy
    const searchLower = searchTerm.trim().toLowerCase(); // Ensure it's a string

    filteredData = filteredData.filter((item) => {
      const fullName = `${item.first_name || ""} ${item.last_name || ""}`.trim().toLowerCase();

      const matchesSearch =
        !searchTerm ||
        fullName.includes(searchLower) || // Match full name
        item.first_name?.trim().toLowerCase().includes(searchLower) ||
        item.last_name?.trim().toLowerCase().includes(searchLower) ||
        item.provider_name?.trim().toLowerCase().includes(searchLower) ||
        item.email?.trim().toLowerCase().includes(searchLower);

      const matchesStatus =
        !statusFilter ||
        String(item.status || "").toLowerCase() === String(statusFilter).toLowerCase();

      return matchesSearch && matchesStatus;
    });

    setCurrentPage(1);
    setData(filteredData);
  }, [tableData, searchTerm, statusFilter]);


  React.useEffect(() => {
    if (!tableData) return;

    let filteredData = [...tableData]; // Ensure you work on a copy

    filteredData = filteredData.filter((item) => {
      const matchesSearch =
        !searchTerm ||
        item.first_name
          ?.trim()
          .toLowerCase()
          .includes(searchTerm.trim().toLowerCase()) ||
        !searchTerm ||
        item.last_name
          ?.trim()
          .toLowerCase()
          .includes(searchTerm.trim().toLowerCase()) ||
        item.provider_name
          ?.trim()
          .toLowerCase()
          .includes(searchTerm.trim().toLowerCase()) ||
        item.email
          ?.trim()
          .toLowerCase()
          .includes(searchTerm.trim().toLowerCase());

      return matchesSearch;
    });

    setData(filteredData);
  }, [tableData, searchTerm]);

  const itemsPerPageOptions = [10, 20, 30, 50];

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  return (
    <>
      <Card flexDirection="column" w="100%" px="0px" overflowX="auto">
        <Flex
          px={{ base: '12px', md: '25px' }}
          mb="8px"
          justifyContent="space-between"
          align="center"
          flexDirection={{ base: 'column', md: 'row' }}
          gap={{ base: 2, md: 0 }}
          w="100%"
        >
          <Text
            color={textColor}
            fontSize="24px"
            fontWeight="700"
            lineHeight="100%"
            mb={{ base: '8px', md: '0px' }}
            textAlign={{ base: 'center', md: 'left' }}
          >
            Clinic Providers{' '}
          </Text>

          <Box
            ml={{ base: 0, md: 'auto' }}
            mr={{ base: 0, md: 5 }}
            w={{ base: '100%', md: 'auto' }}
          >
            <SearchBar
              width="100%"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)} // Trim spaces for consistency
            />{' '}
          </Box>
          <Box mr={{ base: 0, md: 5 }} w={{ base: '100%', md: 'auto' }}>
            <Select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              width="100%"
              maxW={{ base: '100%', md: '200px' }}
              borderRadius="16px"
              fontSize={15}
            >
              <option value="" >
                All status
              </option>

              <option value="enable">Enable</option>
              <option value="disable">Disable</option>
            </Select>
          </Box>

          <Box w={{ base: '100%', md: 'auto' }}>
            <Button
              w="100%"
              // minW={{ base: 'auto', md: '140px' }}
              variant="brand"
              fontWeight="500"
              onClick={() => {
                onOpen();
                setType('add');
              }}
              minH={"36px"}
              borderRadius="16px"
              mb={0}
              size="sm"
            >
              Create Provider
            </Button>
          </Box>
        </Flex>

        <Flex
          px={{ base: '12px', md: '25px' }}
          mb="8px"
          justifyContent="space-between"
          align="center"
          flexDirection={{ base: 'column', md: 'row' }}
          gap={{ base: 2, md: 0 }}
          w="100%"
        >
          <Box w={{ base: '100%', md: 'auto' }}>
            <Select
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
              width={{ base: '100%', md: 'fit-content' }}
              borderRadius="16px"
            >
              {itemsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option} per page
                </option>
              ))}
            </Select>
          </Box>

          <Box
            w={{ base: '100%', md: 'auto' }}
            textAlign={{ base: 'center', md: 'right' }}
          >
            <Pagination
              totalPages={totalPages}
              initialPage={currentPage}
              onPageChange={handlePageChange}
            />{' '}
          </Box>
        </Flex>

        <Box overflowX="auto">
          <Table variant="striped" color="gray.500" mb="24px" mt="12px">
            <Thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <Tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => (
                    <Th
                      key={header.id}
                      colSpan={header.colSpan}
                      pe="10px"
                      borderColor={borderColor}
                      cursor="pointer"
                      onClick={header.column.getToggleSortingHandler()}
                    >
                      <Flex justifyContent="space-between" align="center">
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext(),
                        )}
                      </Flex>
                    </Th>
                  ))}
                </Tr>
              ))}
            </Thead>
            <Tbody>
              {paginatedData.map((row, index) => (
                <Tr key={index}>
                  {table
                    .getRowModel()
                    .rows.find((r) => r.original === row) // Ensure correct row mapping
                    ?.getVisibleCells()
                    ?.map((cell) => (
                      <Td
                        key={cell.id}
                        fontSize="14px"
                        borderColor="transparent"
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext(),
                        )}
                      </Td>
                    ))}
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
        {!loading &&
          data.length === 0 &&
          (searchTerm.length > 0 ? (
            <ErrorMessage source="results" />
          ) : (
            <ErrorMessage source="providers" />
          ))}
      </Card>
      <ProvidersModal
        isOpen={isOpen}
        onClose={onClose}
        type={type}
        providerId={selectedId}
        fetchAgain={fetchAgain}
      />
    </>
  );
}
